import React from "react";
import { Link } from "react-router-dom";
import { BsHouses, BsKey, BsLock, BsFileEarmarkLock, BsMoon } from "react-icons/bs";

export default function SidebarNav({ isActive, usersOpen, handleUsersClick, accessOpen, handleAccessClick, competitionOpen, handleCompetitionClick, logedUser, isMobile, closeMobile }) {
const navItemClass = (active) =>
  `
  group flex items-center gap-3 rounded-xl px-3 py-2.5 text-xs font-medium
  transition-all duration-200
  ${
    active
      ? "bg-white/15 text-white shadow-sm"
      : "text-white/70 hover:bg-white/10 hover:text-white"
  }
  `;
  return (
    <nav className="flex-1 px-4 py-6 border-gray-700 overflow-y-auto">
      <Link to="/" onClick={() => isMobile && closeMobile()} className={` text-xs ${navItemClass(isActive("/"))}`}>
        <BsHouses className="w-4 h-4" />
        Główna
      </Link>
        {/* Licencje */}
      <Link to="/licenses" onClick={() => isMobile && closeMobile()} className={`text-xs mt-2 ${navItemClass(isActive("/licenses"))}`}>
        <BsKey className="w-4 h-4" />
        Licencje
      </Link>
 {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") && (
              <></>
            )}
      {/* Rozliczenia */}
      <div className="mt-2">
        <button
  onClick={handleCompetitionClick}
  className="group flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-xs font-medium text-white/70 transition-all duration-200 hover:bg-white/10 hover:text-white"
>
  <div className="flex items-center gap-3">
    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white/70 transition-all group-hover:bg-white/20 group-hover:text-white">
      <BsMoon className="h-4 w-4" />
    </span>

    <span>
      Cenniki konkurencji
    </span>
  </div>

  <span className="text-[10px] text-white/50 transition-transform duration-200">
    {competitionOpen ? "▲" : "▼"}
  </span>
</button>

          {competitionOpen && (
            <div className="pl-6 mt-1 space-y-1 transition-all duration-300 text-xs">
              <Link to="/priceconcurent" className={navItemClass(isActive("/priceconcurent"))}>Indeksy zapisane</Link>
              <Link to="/priceconcurrentmissed" className={navItemClass(isActive("/priceconcurrentmissed"))}>Indeksy do zgłoszenia</Link>
            </div>
          )}

       <button
  onClick={handleUsersClick}
  className="group flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-xs font-medium text-white/70 transition-all duration-200 hover:bg-white/10 hover:text-white"
>
  <div className="flex items-center gap-3">
    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white/70 transition-all group-hover:bg-white/20 group-hover:text-white">
      <BsFileEarmarkLock className="h-4 w-4" />
    </span>

    <span>
      Rozliczenia
    </span>
  </div>

  <span className="text-[10px] text-white/50 transition-transform duration-200">
    {usersOpen ? "▲" : "▼"}
  </span>
</button>

        {usersOpen && (
          <div className="pl-6 mt-1 space-y-1 transition-all duration-300 text-xs">
            <Link to="/licensesettlement" className={navItemClass(isActive("/licensesettlement"))}>
              Rozliczenie licencji
            </Link>
            {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") && (
              <div>

              <Link to="/marketing" className={navItemClass(isActive("/marketing"))}>
                Marketing
              </Link>
               <Link to="/anamorphic-parallax" className={navItemClass(isActive("/anamorphic-parallax"))}>
                Anamorphic Parallax
              </Link>
              </div>
            )}
             {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") && (
              <Link to="/koszty" className={navItemClass(isActive("/koszty"))}>
                Koszty systemu
              </Link>
              
            )}
          </div>
        )}
      </div>

      {/* Dostępy */}
      {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") && (
        <div className="mt-2">
         
          <button
  onClick={handleAccessClick}
  className="group flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-xs font-medium text-white/70 transition-all duration-200 hover:bg-white/10 hover:text-white"
>
  <div className="flex items-center gap-3">
    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white/70 transition-all group-hover:bg-white/20 group-hover:text-white">
      <BsFileEarmarkLock className="h-4 w-4" />
    </span>

    <span>
      Dostępy
    </span>
  </div>

  <span className="text-[10px] text-white/50 transition-transform duration-200">
    {accessOpen ? "▲" : "▼"}
  </span>
</button>

          {accessOpen && (
            <div className="pl-6 mt-1 space-y-1 transition-all duration-300 text-xs">
              <Link to="/users" className={navItemClass(isActive("/users"))}>Użytkownicy</Link>
              <Link to="/vendors" className={navItemClass(isActive("/vendors"))}>Dystrybutorzy</Link>
            </div>
          )}

  


        </div>
      )}

    
    </nav>
  );
}
